import { render, staticRenderFns } from "./LowerCourt.vue?vue&type=template&id=0c2deb57"
import script from "./LowerCourt.vue?vue&type=script&lang=js"
export * from "./LowerCourt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports